import { Autoplay } from 'swiper/modules';

export default {
  moduleEls: document.querySelectorAll('.module-text-image-slider'),
  els: [],
  init(Swiper, Navigation, Pagination) {
    if (!this.moduleEls.length) {
      return;
    }

    this.moduleEls.forEach((el) => {
      this.els.push(el.querySelector('.js-swiper-tis'));
    });

    this.els.forEach((el, index) => {
      let options = {};

      if (el.dataset.options) {
        options = JSON.parse(el.dataset.options.replace(/'/g, '"'));
      }

      options.modules = [Navigation, Pagination, Autoplay];

      const swiper = new Swiper(el, options);

      const btnNext = this.moduleEls[index].querySelector(
        '.swiper-button-next'
      );
      const btnPrev = this.moduleEls[index].querySelector(
        '.swiper-button-prev'
      );

      btnNext.addEventListener('click', () => {
        swiper.slideNext();
      });

      btnPrev.addEventListener('click', () => {
        swiper.slidePrev();
      });

      const bullets = this.moduleEls[index].querySelectorAll(
        '.swiper-pagination-bullet'
      );
      bullets.forEach((bullet, bulletIndex) => {
        bullet.addEventListener('click', () => {
          swiper.slideTo(bulletIndex);
        });
      });

      swiper.on('slideChange', () => {
        this.enableDisableButtons(swiper, btnNext, btnPrev);

        bullets.forEach((bullet) => {
          bullet.classList.remove('swiper-pagination-bullet-active');
        });

        bullets[swiper.realIndex].classList.add(
          'swiper-pagination-bullet-active'
        );
      });

      let initialized = false;
      let prevIndex = 0;
      swiper.on('autoplayTimeLeft', (data) => {
        const { timeLeft } = data.autoplay;
        const timeTotal = options.autoplay.delay;
        const slideIndex = data.activeIndex;
        const delta = Math.min(1 - timeLeft / timeTotal, 1);

        if (prevIndex !== slideIndex) {
          if (slideIndex === 0) {
            bullets.forEach((bullet) => {
              bullet.style.setProperty('--barWidth', '0%');
            });
          } else {
            bullets[prevIndex].style.setProperty('--barWidth', '100%');
          }
          prevIndex = slideIndex;
        }

        bullets[slideIndex].style.setProperty(
          '--barWidth',
          `${(delta * 100).toFixed(2)}%`
        );
      });

      swiper.on('autoplayStop', () => {
        if (!initialized) return;
        bullets.forEach((bullet) => {
          bullet.style.setProperty('--barWidth', '0%');
          bullet.classList.add('autoplay-stopped');
        });
      });
      setTimeout(() => {
        swiper.autoplay.stop();
        initialized = true;
      }, 10);

      window.smr_eventbus.on('observer:InView', (el) => {
        if (!el.classList.contains('module-text-image-slider')) return;
        if (el !== this.moduleEls[index]) return;
        window.smr_observer.removeEl(el);
        setTimeout(() => {
          swiper.autoplay.start();
        }, 20);
      });
    });
  },
  enableDisableButtons(swiper, btnNext, btnPrev) {
    btnNext.classList.remove('swiper-button-disabled');
    btnPrev.classList.remove('swiper-button-disabled');

    if (swiper.isBeginning) {
      btnPrev.classList.add('swiper-button-disabled');
    }

    if (swiper.isEnd) {
      btnNext.classList.add('swiper-button-disabled');
    }
  },
};
